import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Languages } from 'lucide-react'
import { Button } from '@/components/shadcn/button'
import { TranslationsDialog } from './TranslationsDialog'

interface TranslateButtonProps {
  dialogTitle?: string
  value: Record<string, string>
  onChange: (translations: Record<string, string>) => void
}

/** Icon button next to an input field, opens the buffered TranslationsDialog. */
export function TranslateButton({ dialogTitle, value, onChange }: TranslateButtonProps) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="icon"
        title={t('translations.editTranslations')}
        onClick={() => setOpen(true)}
      >
        <Languages className='text-primary' />
      </Button>
      <TranslationsDialog
        open={open}
        onOpenChange={setOpen}
        title={dialogTitle}
        value={value}
        onApply={onChange}
      />
    </>
  )
}
